import { Navigate, useLocation, useParams } from "react-router-dom";
import { PROJECT_WORKSPACE_CONFIG } from "./projectWorkspaceConfig";
import { buildProjectWorkspacePath } from "./projectWorkspacePaths";

const LEGACY_SECTION_BY_PATH = [
  { match: "CheckNewRequest", section: "initial-review" },
  { match: "InProcessRequest", section: "operational" },
  { match: "AllRequests", section: "overview" },
  { match: "AllRequest", section: "overview" },
  { match: "/Request/", section: "initial-review" },
];

const resolveLegacySection = (pathname = "") => {
  const hit = LEGACY_SECTION_BY_PATH.find((item) =>
    pathname.includes(item.match)
  );
  return hit?.section || "overview";
};

/**
 * Legacy route wrapper: /CheckNewRequest/:id, /InProcessRequest/:id, /AllRequests/:id → ProjectWorkspace
 */
const ProjectWorkspaceRedirect = ({ configKey = "solarentOperator" }) => {
  const { id } = useParams();
  const location = useLocation();
  const cfg = PROJECT_WORKSPACE_CONFIG[configKey];
  const target = buildProjectWorkspacePath(id, configKey);

  if (!target) {
    return <Navigate to={cfg?.listPaths?.checkNew || "/SLN/SolarentOperator/CheckNewRequest"} replace />;
  }

  const section = resolveLegacySection(location.pathname);
  return <Navigate to={`${target}?section=${section}`} replace />;
};

export default ProjectWorkspaceRedirect;
